module.exports = __webpack_public_path__ + "img/图1-15狭小部位的尺寸注法.f5bdf938.jpg";